import moment from "moment/moment";

export default function changeDateFormat (date, format) {
  if (!date) {
    return 'N/A'
  }
  return moment(date, 'YYYY-MM-DD').format(format);
}



// WEBPACK FOOTER //
// ./src/app/filters/changeDateFormat.js